(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	Voonto.getInstance().define(['module'], function (module) {
	    var Logger = nibara.logger;
	
	    return {
	        wakeUp: function wakeUp($elm) {
	            Logger.info('wake up module ' + module.id);
	            var app = Voonto.getInstance();
	
	            var nibaraLoader = Voonto.$('body').data('nibara-loader');
	            Logger.info('[taboola] nibaraLoader: ' + nibaraLoader);
	
	            var template = $elm.data('template-taboola');
	            Logger.info('[taboola] template: ' + template);
	
	            // wait to finish document load
	            Voonto.$(document).ready(function () {
	                Logger.info('[taboola] DOM load finished continue loading taboola widgets');
	
	                // First script
	                window._taboola = window._taboola || [];
	                _taboola.push({ article: 'auto' });
	                !function (e, f, u, i) {
	                    if (!document.getElementById(i)) {
	                        e.async = 1;
	                        e.src = u;
	                        e.id = i;
	                        f.parentNode.insertBefore(e, f);
	                    }
	                }(document.createElement('script'), document.getElementsByTagName('script')[0], '//cdn.taboola.com/libtrc/vocentoabc-network/loader.js', 'tb_loader_script');
	                if (window.performance && typeof window.performance.mark == 'function') {
	                    window.performance.mark('tbl_ic');
	                }
	
	                // Second script
	                var id = $elm.attr('id');
	                if ('taboola-below-article-thumbnails' === id) {
	                    Logger.info('[taboola] Widget JS desktop');
	                    window._taboola = window._taboola || [];
	                    _taboola.push({
	                        mode: 'thumbnails-a',
	                        container: 'taboola-below-article-thumbnails',
	                        placement: 'Below Article Thumbnails',
	                        target_type: 'mix'
	                    });
	                    window._taboola = window._taboola || [];
	                    _taboola.push({
	                        mode: 'organic-thumbnails-a',
	                        container: 'taboola-organic-below-article-thumbnails',
	                        placement: 'Organic Below Article Thumbnails',
	                        target_type: 'mix'
	                    });
	                } else if ('taboola-mobile-below-article-thumbnails' === id) {
	                    Logger.info('[taboola] Widget JS mobile');
	                    window._taboola = window._taboola || [];
	                    _taboola.push({
	                        mode: 'thumbnails-b',
	                        container: 'taboola-mobile-below-article-thumbnails',
	                        placement: 'Mobile Below Article Thumbnails',
	                        target_type: 'mix'
	                    });
	                    window._taboola = window._taboola || [];
	                    _taboola.push({
	                        mode: 'organic-thumbnails-b',
	                        container: 'taboola-mobile-organic-below-article-thumbnails',
	                        placement: 'Mobile Organic Below Article Thumbnails',
	                        target_type: 'mix'
	                    });
	                } else if ('taboola-below-article-thumbnails-2nd' === id) {
	                    Logger.info('[taboola] Feed JS');
	                    window._taboola = window._taboola || [];
	                    _taboola.push({
	                        mode: 'thumbnails-c',
	                        container: 'taboola-below-article-thumbnails-2nd',
	                        placement: 'Below Article Thumbnails 2nd',
	                        target_type: 'mix'
	                    });
	                }
	
	                // Third script
	                window._taboola = window._taboola || [];
	                _taboola.push({ flush: true });
	            });
	        }
	    };
	});

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// taboola-module.js